import { loadSkillsFromJsonByGroup, loadJuniorASkillsFromJson } from './jsonSkillsLoader';

import fxSkillsJson from './fxSkills2025.json';
import phSkillsJson from './phSkills2025.json';
import ringsSkillsJson from './ringsSkills2025.json';
import vaultSkillsJson from './vaultSkills2025.json';
import pbarsSkillsJson from './pbarsSkills2025.json';
import hbarSkillsJson from './hbarSkills2025.json';
import juniorASkillsJson from './juniorASkills.json';
import pommellessSkillsJson from './pommellessSkills.json';

const fxSkills = loadSkillsFromJsonByGroup(fxSkillsJson, 'FX', 'FX');
const phSkills = loadSkillsFromJsonByGroup(phSkillsJson, 'PH', 'PH');
const srSkills = loadSkillsFromJsonByGroup(ringsSkillsJson, 'SR', 'RG');
const vtSkills = loadSkillsFromJsonByGroup(vaultSkillsJson, 'VT', 'VT');
const pbSkills = loadSkillsFromJsonByGroup(pbarsSkillsJson, 'PB', 'PB');
const hbSkills = loadSkillsFromJsonByGroup(hbarSkillsJson, 'HB', 'HB');
const plSkills = loadSkillsFromJsonByGroup(pommellessSkillsJson, 'PL', 'PLH');

const juniorASkills = loadJuniorASkillsFromJson(juniorASkillsJson);

const combineSkills = (regularSkills, juniorSkills) => {
  return [...regularSkills, ...juniorSkills];
};

export const skillsData = {
  FX: combineSkills(fxSkills, juniorASkills.FX),
  PH: combineSkills(phSkills, juniorASkills.PH),
  SR: combineSkills(srSkills, juniorASkills.SR),
  VT: combineSkills(vtSkills, juniorASkills.VT),
  PB: combineSkills(pbSkills, juniorASkills.PB),
  HB: combineSkills(hbSkills, juniorASkills.HB),
  PL: combineSkills(plSkills, [])
};

export const additionalEgIISkills = [
  {
    name: "Salto forward tucked or piked with 1/1 turn",
    code: "FX-EG2-13",
    value: 0.2,
    group: "EG II",
    cvEligible: true,
    stickBonusEligible: false,
    juniorAllowed: true,
    groupIElement: false,
    apparatus: "FX",
    active: true
  },
  {
    name: "Salto forward tucked or piked with 3/2 turn",
    code: "FX-EG2-14",
    value: 0.3,
    group: "EG II",
    cvEligible: true,
    stickBonusEligible: false,
    juniorAllowed: true,
    groupIElement: false,
    apparatus: "FX",
    active: true
  }
];

export const additionalEgISkills = [
  {
    name: "From handstand, lower to L-sit or straddle L-sit (2s)",
    code: "FX-EG1-1",
    value: 0.1,
    group: "EG I",
    cvEligible: false,
    stickBonusEligible: false,
    juniorAllowed: true,
    groupIElement: true,
    apparatus: "FX",
    active: true
  },
  {
    name: "V-sit (2s)",
    code: "FX-EG1-2",
    value: 0.2,
    group: "EG I",
    cvEligible: false,
    stickBonusEligible: false,
    juniorAllowed: true,
    groupIElement: true,
    apparatus: "FX",
    active: true
  }
];

export const bonusOptions = [
  { name: 'Stuck Dismount', value: 0.2, applied: false },
  { name: 'Connection Value', value: 0.1, applied: false },
  { name: 'D-Value or Higher Connection', value: 0.2, applied: false },
  { name: 'Virtuosity', value: 0.1, applied: false }
];

export function getSkillsForEvent(event) {
  return skillsData[event] || [];
}

export function getSkillByCode(code) {
  for (const event of Object.keys(skillsData)) {
    const skill = skillsData[event].find(s => s.code === code);
    if (skill) return skill;
  }
  return undefined;
}

export function getSkillsByGroup(event, group) {
  return (skillsData[event] || []).filter(skill => skill.group === group);
}
